import { Injectable } from "@angular/core";
import { IFile, IFileFilter } from "./file.interface";
import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import * as _ from 'lodash';
import { HttpService } from "../../../../http.service";
import { UtilsService } from "../../services/utils.service";
import { apiURL, EnvConfig } from "../../../../env-config";

@Injectable()
export class FileService {
  constructor(
    private _http: HttpService,
    private _utilsService: UtilsService,
  ) { }

  getFiles(filter?: IFileFilter): Observable<IFile[]> {
    let queryParams: string = !_.isEmpty(filter) ? '?' + this._utilsService.toQueryString(filter) : '';
    return this._http.get(`${apiURL(EnvConfig.API_FILES)}${queryParams}`);
  }

  getFile(file: IFile | string): Observable<IFile[]> {
    let id = (typeof file == 'string') ? file : file._id;
    return this._http.get(`${apiURL(EnvConfig.API_FILES)}/${id}`);
  }

  uploadFile(data: any): Promise<any> {
    return this._http.post(`${apiURL(EnvConfig.API_FILES)}`, data).toPromise();
  }
}